// reducers/employee-onboarding/notify.js

export function notifyHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_NOTIFY_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function notifyIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_NOTIFY_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function notify(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_NOTIFY_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}